"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validEmail = exports.addNullError = exports.fieldHasErrors = void 0;
exports.validateEmailField = validateEmailField;
exports.validateEmailsField = validateEmailsField;
exports.validatePhoneNumbersField = validatePhoneNumbersField;
exports.lengthNoMoreThan = lengthNoMoreThan;
exports.lengthNoLessThan = lengthNoLessThan;
exports.blankError = blankError;
exports.validateFirstNamePresence = validateFirstNamePresence;
exports.validateLastNamePresence = validateLastNamePresence;
exports.validateGenderPresence = validateGenderPresence;
exports.validatePhoneNumberPresence = validatePhoneNumberPresence;
exports.validateBirthdate = validateBirthdate;
exports.validateCurrentPasswordPresence = validateCurrentPasswordPresence;
exports.validateNewPassword = validateNewPassword;
exports.validatePasswordConfirmation = validatePasswordConfirmation;
exports.validateFieldMaxLength = validateFieldMaxLength;
exports.validateHouseholdMemberCreateFields = validateHouseholdMemberCreateFields;
exports.validateProfileData = validateProfileData;
exports.validateContactInfoData = validateContactInfoData;
exports.validateProfileFormFields = validateProfileFormFields;
exports.validateLoginFormFields = validateLoginFormFields;
const utils_1 = require("core/utils");
const object_utils_1 = require("utils/object-utils");
const validator = __importStar(require("validator"));
// general use validation
const fieldHasErrors = (errorArray) => errorArray.length > 0;
exports.fieldHasErrors = fieldHasErrors;
const addNullError = (fieldName, errorArray) => errorArray.push(`You must enter a ${fieldName}`);
exports.addNullError = addNullError;
const validEmail = (value) => value && validator.isEmail(value);
exports.validEmail = validEmail;
function validateEmailField(emailAddress, isRequired, isUser = false) {
    const emailAddressErrors = [];
    const nullOrBlank = !emailAddress || emailAddress === '';
    if (nullOrBlank) {
        if (isUser) {
            // @ts-ignore
            emailAddressErrors.push(['A valid email address is required']);
        }
        if (isRequired) {
            // @ts-ignore
            emailAddressErrors.push(['Invalid email address']);
        }
    }
    else {
        if (!(0, exports.validEmail)(emailAddress)) {
            // @ts-ignore
            emailAddressErrors.push(['Invalid email address']);
        }
        lengthNoMoreThan('Email address', emailAddress, 150, emailAddressErrors);
    }
    return emailAddressErrors;
}
function validateEmailsField(emailAddresses, isRequired, isUser = false) {
    emailAddresses = emailAddresses || [];
    const emailAddressesErrors = {};
    const nullOrBlank = emailAddresses.length === 0 || emailAddresses[0]?.value === '';
    if (nullOrBlank) {
        if (isRequired || isUser) {
            emailAddressesErrors[0] = ['A valid email address is required'];
        }
    }
    emailAddresses.forEach((ea, index) => {
        if (!ea?.value) {
            emailAddressesErrors[index] = ['email address cannot be blank'];
        }
        else {
            if (!(0, exports.validEmail)(ea.value)) {
                emailAddressesErrors[index] = ['Invalid email address'];
            }
            lengthNoMoreThan('Email address', ea.value, 150, emailAddressesErrors[index]);
        }
    });
    return emailAddressesErrors;
}
function validatePhoneNumbersField(phoneNumbers, isRequired) {
    phoneNumbers = phoneNumbers || [];
    const phoneNumbersErrors = {};
    const nullOrBlank = phoneNumbers.length === 0 || phoneNumbers[0]?.value === '';
    if (nullOrBlank) {
        if (isRequired) {
            phoneNumbersErrors[0] = ['A phone number is required'];
        }
    }
    phoneNumbers.forEach((pn, index) => {
        if (!pn?.value) {
            phoneNumbersErrors[index] = ['phone number cannot be blank'];
        }
    });
    return phoneNumbersErrors;
}
function lengthNoMoreThan(fieldName, value, maxLength, errorArray) {
    if (value.length > maxLength) {
        return errorArray.push(`${fieldName} cannot be more than ${maxLength} characters`);
    }
}
function lengthNoLessThan(fieldName, value, minLength, errorArray) {
    if (value.length < minLength) {
        return errorArray.push(`${fieldName} must be at least ${minLength} characters`);
    }
}
function blankError(fieldName, value, errorArray) {
    if (value.length === 0) {
        return errorArray.push(`You must enter a ${fieldName}`);
    }
}
// field specific validation
function validateFirstNamePresence(value) {
    const firstNameErrors = [];
    // no need to return in these. validations will push errors to the array
    if (!value) {
        (0, exports.addNullError)('first name', firstNameErrors);
    }
    else {
        lengthNoMoreThan('First Name', value, 40, firstNameErrors);
        blankError('first name', value, firstNameErrors);
        // will return nothing here if validaitons pass
    }
    return firstNameErrors;
}
function validateLastNamePresence(value) {
    const lastNameErrors = [];
    // no need to return in these. validations will push errors to the array
    if (!value) {
        (0, exports.addNullError)('last name', lastNameErrors);
    }
    else {
        lengthNoMoreThan('Last Name', value, 40, lastNameErrors);
        blankError('last name', value, lastNameErrors);
        // will return nothing here if validations pass
    }
    return lastNameErrors;
}
function validateGenderPresence(value) {
    const genderErrors = [];
    // no need to return in these. validations will push errors to the array
    if (!value) {
        (0, exports.addNullError)('gender', genderErrors);
    }
    return genderErrors;
}
function validatePhoneNumberPresence(value) {
    const phoneErrors = [];
    // no need to return in these. validations will push errors to the array
    if (!value) {
        (0, exports.addNullError)('phone number', phoneErrors);
    }
    return phoneErrors;
}
function validateBirthdate(value, required, plainBirthdate) {
    const birthdateErrors = [];
    // moment doesn't return the text if the string doesn't parse to meet the format,
    // it returns null. We have forms where null (blank) birthdate is okay so we have
    // no way to differentiate here which nulls are blank vs bad data. plainBirthdate
    // is the raw value the user typed. We check it against the regex below. If it
    // doesn't match, add an error and return because we know birthdate isn't blank.
    const regex = /^\d{1,2}\/\d{1,2}\/\d{4}$/;
    if (plainBirthdate && !regex.test(plainBirthdate)) {
        // @ts-ignore
        birthdateErrors.push('You must enter the date in the format M/D/YYYY');
        return birthdateErrors;
    }
    // return here because we don't want to validate the date if it's not present
    // and it should be
    if (!value && required) {
        (0, exports.addNullError)('birthdate', birthdateErrors);
        return birthdateErrors;
    }
    // since plainBirthdate is checked above and returns an error, we can assume at
    // this point the user has not made a change to the form (which would set plainBirthdate)
    // If the user has a value in the field  that matches the regex, we want to
    // check that it's a valid moment date (ex. you didn't enter 5/50/5050)
    if (value || plainBirthdate) {
        const date = value ? (0, utils_1.parseDate)(value, 'YYYY-M-DD') : (0, utils_1.parseDate)(plainBirthdate, 'YYYY-M-DD');
        if (!date.isValid()) {
            // @ts-ignore
            birthdateErrors.push('You must enter the date in the format M/D/YYYY');
        }
    }
    return birthdateErrors;
}
// current password is only required if a user tries to enter a new password or
// confirm password and an email address is supplied
function validateCurrentPasswordPresence(currentPassword, password, passwordConfirmation) {
    const currentPasswordErrors = [];
    if ((password || passwordConfirmation) && !currentPassword) {
        // @ts-ignore
        currentPasswordErrors.push('You must specify your existing password');
    }
    return currentPasswordErrors;
}
function validateNewPassword(password, emailAddress, passwordConfirmation) {
    const passwordErrors = [];
    if (password) {
        lengthNoLessThan('Password', password, 8, passwordErrors);
        lengthNoMoreThan('Password', password, 255, passwordErrors);
        if (password === emailAddress) {
            // @ts-ignore
            passwordErrors.push('Password cannot be same as email');
        }
    }
    if (!password && passwordConfirmation) {
        lengthNoLessThan('Password', '', 8, passwordErrors);
    }
    return passwordErrors;
}
function validatePasswordConfirmation(passwordConfirmation, newPassword) {
    const passwordConfirmationErrors = [];
    if (passwordConfirmation !== newPassword) {
        // @ts-ignore
        passwordConfirmationErrors.push('New Password and Confirm Password must match exactly');
    }
    return passwordConfirmationErrors;
}
function validateFieldMaxLength(fieldText, value, maxlength) {
    const fieldErrors = [];
    if (value) {
        lengthNoMoreThan(fieldText, value, maxlength, fieldErrors);
        // will return nothing here if validations pass
    }
    return fieldErrors;
}
// form specific validation
function validateHouseholdMemberCreateFields(householdMember) {
    const formErrors = {};
    // firstName
    const firstNameErrors = validateFirstNamePresence(householdMember.firstName);
    if ((0, exports.fieldHasErrors)(firstNameErrors)) {
        formErrors.firstName = firstNameErrors;
    }
    // lastName
    const lastNameErrors = validateLastNamePresence(householdMember.lastName);
    if ((0, exports.fieldHasErrors)(lastNameErrors)) {
        formErrors.lastName = lastNameErrors;
    }
    // the formatting of the birthdate is caught in the component itself, but
    // this form also makes it required
    const birthdateErrors = validateBirthdate(householdMember.birthdate, true, householdMember.plainBirthdate);
    if ((0, exports.fieldHasErrors)(birthdateErrors)) {
        formErrors.birthdate = birthdateErrors;
    }
    // email
    const emailAddressErrors = validateEmailField(householdMember.emailAddress, false);
    if ((0, exports.fieldHasErrors)(emailAddressErrors)) {
        formErrors.emailAddress = emailAddressErrors;
    }
    return formErrors;
}
function validateProfileData(profileData, { birthdateRequired = false, plainBirthdate = null, genderRequired = false } = {}) {
    const profileErrors = {};
    // firstName
    const firstNameErrors = validateFirstNamePresence(profileData.firstName);
    if ((0, exports.fieldHasErrors)(firstNameErrors)) {
        profileErrors.firstName = firstNameErrors;
    }
    // lastName
    const lastNameErrors = validateLastNamePresence(profileData.lastName);
    if ((0, exports.fieldHasErrors)(lastNameErrors)) {
        profileErrors.lastName = lastNameErrors;
    }
    // birthdate
    const birthdateErrors = validateBirthdate(profileData.birthdate, birthdateRequired, plainBirthdate);
    if ((0, exports.fieldHasErrors)(birthdateErrors)) {
        profileErrors.birthdate = birthdateErrors;
    }
    const genderErrors = validateGenderPresence(profileData.gender);
    if (genderRequired && (0, exports.fieldHasErrors)(genderErrors)) {
        profileErrors.gender = genderErrors;
    }
    return profileErrors;
}
function validateContactInfoData(contactData, { emailRequired = false, isUser = false, phoneRequired = false, repeaterEmail = false, repeaterPhone = false } = {}) {
    const contactErrors = {};
    if (repeaterEmail) {
        const emailAddressesErrors = validateEmailsField(contactData.emailAddresses, emailRequired, isUser);
        if ((0, exports.fieldHasErrors)(Object.values(emailAddressesErrors))) {
            contactErrors.emailAddresses = emailAddressesErrors;
        }
    }
    else {
        const emailAdressErrors = validateEmailField(contactData.emailAddress, emailRequired, isUser);
        if ((0, exports.fieldHasErrors)(emailAdressErrors)) {
            contactErrors.emailAddress = emailAdressErrors;
        }
    }
    // contact information section
    if (repeaterPhone) {
        const phoneNumbersErrors = validatePhoneNumbersField(contactData.phoneNumbers, phoneRequired);
        if ((0, exports.fieldHasErrors)(Object.values(phoneNumbersErrors))) {
            contactErrors.phoneNumbers = phoneNumbersErrors;
        }
    }
    else {
        // phone number 1
        const phoneNumber1Errors = validateFieldMaxLength('Phone number', contactData.phoneNumber1, 30);
        if (phoneRequired) {
            blankError('phone number', contactData.phoneNumber1, phoneNumber1Errors);
        }
        if ((0, exports.fieldHasErrors)(phoneNumber1Errors)) {
            contactErrors.phoneNumber1 = phoneNumber1Errors;
        }
        //  phone number 2
        const phoneNumber2Errors = validateFieldMaxLength('Phone number', contactData.phoneNumber2, 30);
        if ((0, exports.fieldHasErrors)(phoneNumber2Errors)) {
            contactErrors.phoneNumber2 = phoneNumber2Errors;
        }
    }
    // address street 1
    const addressStreet1Errors = validateFieldMaxLength('Address', contactData.addressStreet1, 100);
    if ((0, exports.fieldHasErrors)(addressStreet1Errors)) {
        contactErrors.addressStreet1 = addressStreet1Errors;
    }
    // address street 2
    const addressStreet2Errors = validateFieldMaxLength('Address', contactData.addressStreet2, 100);
    if ((0, exports.fieldHasErrors)(addressStreet2Errors)) {
        contactErrors.addressStreet2 = addressStreet2Errors;
    }
    // address city
    const addressCityErrors = validateFieldMaxLength('City', contactData.addressCity, 50);
    if ((0, exports.fieldHasErrors)(addressCityErrors)) {
        contactErrors.addressCity = addressCityErrors;
    }
    // address state
    const addressStateErrors = validateFieldMaxLength('State', contactData.addressState, 30);
    if ((0, exports.fieldHasErrors)(addressStateErrors)) {
        contactErrors.addressState = addressStateErrors;
    }
    // zip code
    const addressZipErrors = validateFieldMaxLength('Zip/Postcal Code', contactData.addressZipcode, 30);
    if ((0, exports.fieldHasErrors)(addressZipErrors)) {
        contactErrors.addressZipcode = addressZipErrors;
    }
    return contactErrors;
}
function validateProfileFormFields(profileData, contactData, { emailRequired = false, birthdateRequired = false, genderRequired = false, phoneRequired = false, isUser = false, plainBirthdate = null, repeaterEmail = false, repeaterPhone = false, } = {}) {
    const formErrors = { profile: {}, contactInfos: {} };
    const profileSectionErrors = validateProfileData(profileData, {
        genderRequired,
        birthdateRequired,
        plainBirthdate,
    });
    if (!(0, object_utils_1.isDeepEmpty)(profileSectionErrors)) {
        formErrors.profile = profileSectionErrors;
    }
    const contactInfoSectionErrors = validateContactInfoData(contactData, {
        emailRequired,
        phoneRequired,
        isUser,
        repeaterEmail,
        repeaterPhone,
    });
    if (!(0, object_utils_1.isDeepEmpty)(contactInfoSectionErrors)) {
        formErrors.contactInfos = contactInfoSectionErrors;
    }
    return formErrors;
}
// login form validations
function validateLoginFormFields(loginFormData) {
    const formErrors = {};
    // email
    // if email address is missing, we do not run any of the other validations
    const emailAddressErrors = validateEmailField(loginFormData.email, true);
    if ((0, exports.fieldHasErrors)(emailAddressErrors)) {
        formErrors.email = emailAddressErrors;
        return formErrors;
    }
    // current password
    const currentPasswordErrors = validateCurrentPasswordPresence(loginFormData.currentPassword, loginFormData.password, loginFormData.passwordConfirmation);
    if ((0, exports.fieldHasErrors)(currentPasswordErrors)) {
        formErrors.currentPassword = currentPasswordErrors;
    }
    // new password
    const passwordErrors = validateNewPassword(loginFormData.password, loginFormData.email, loginFormData.passwordConfirmation);
    if ((0, exports.fieldHasErrors)(passwordErrors)) {
        formErrors.password = passwordErrors;
    }
    // password confirmation
    const passwordConfirmationErrors = validatePasswordConfirmation(loginFormData.passwordConfirmation, loginFormData.password);
    if ((0, exports.fieldHasErrors)(passwordConfirmationErrors)) {
        formErrors.passwordConfirmation = passwordConfirmationErrors;
    }
    return formErrors;
}
